import { CONFIG_KEYS, getClientConfigBool } from '../config';

// These are the same as we're now deciding which one is enabled in the
// nginx configuration, as they live on the same path.
const prefixIdentity = '/account';
const prefixAccount = '/account';
export function incBaseIdentity(path) {
  return prependPrefix(path, prefixIdentity);
}
export function incBaseAccount(path) {
  return prependPrefix(path, prefixAccount);
}
function prependPrefix(path, prefix) {
  const separator = path.startsWith('/') || path === '' ? '' : '/';
  return "".concat(prefix).concat(separator).concat(path);
}
function isPrefixedPath(path, prefix) {
  return new RegExp("".concat(prefix, "(\\/.*)?$")).test(path);
}
export function isIdentityPath(path) {
  return isPrefixedPath(path, prefixIdentity);
}
export function isAccountPath(path) {
  return isPrefixedPath(path, prefixAccount);
}
export function incBase(path, accountPath) {
  return accountEnabled() ? incBaseAccount(removeAccountPrefix(accountPath !== null && accountPath !== void 0 ? accountPath : path)) : incBaseIdentity(path);
}
export function removeAccountPrefix(path) {
  return path.replace(/^\/?account(\/|$)/, '');
}
function accountEnabled() {
  return getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_ACCOUNT_NEXT_ENABLED);
}